<script setup lang="ts">
  import { MpLoadingContainer, MpText } from '@borg/ui';

  const { t } = useI18n();
  const route = useRoute();
  const organizationCard = useOrganizationCard.provide();

  const organizationId = parseInt(route.params.employerId as string, 10);

  const organizationName = computed(() => organization.value?.name ?? undefined);

  const tagTitle = computed(() =>
    organizationName.value
      ? `${t('ORGANIZATION_PROFILE_PAGE.TITLE')} - ${organizationName.value}`
      : t('ORGANIZATION_PROFILE_PAGE.TITLE'),
  );

  const tagImage = computed(() =>
    organization.value?.logoUrl && !!organization.value.logoUrl
      ? organization.value.logoUrl
          .replace(/-\d+x\d+x\d+./, '-600x315x85.')
          .replace(/-fit-/, '-frame-')
      : undefined,
  );
  const tagImageWidth = computed(() => (tagImage.value ? 600 : undefined));
  const tagImageHeight = computed(() => (tagImage.value ? 315 : undefined));

  // todo - handle error and reload
  const { data: organization, pending: pendingOrganization } =
    await organizationRepository.get(organizationId);

  // wait for organization data and redirect when loaded
  const { getEmployerProfileUrl } = useEmployerUrl();

  watch(organization, (org) => {
    if (org?.name) {
      const expectedUrl = getEmployerProfileUrl(organizationId, org.name);

      // if current url isnt matched to expected slug, do the redirect
      if (route.path !== expectedUrl) {
        navigateTo(expectedUrl, { replace: true });
      }
    }
  }, { immediate: true });
  const { data: jobs, pending: pendingOrganizationJobs } =
    await organizationJobsRepository.getMany(organizationId);

  useHead({
    title: tagTitle,
  });

  useSeoMeta({
    ogTitle: tagTitle,
    ogImage: tagImage,
    ogImageWidth: tagImageWidth,
    ogImageHeight: tagImageHeight,
  });

  watch(
    organization,
    (value) => {
      if (value) {
        organizationCard.set(value);
      }
    },
    { immediate: true },
  );
</script>

<template>
  <MpLoadingContainer :is-loading="pendingOrganization || pendingOrganizationJobs">
    <LayoutGrid v-if="organization">
      <MpText as="h1">
        {{ organizationName }}
      </MpText>
      <WebView
        :html="organization.content"
        style="width: 100%"
      />
      <template #aside>
        <OrganizationCard />
        <OrganizationJobsCard
          v-if="jobs"
          :jobs="jobs"
        />
        <OrganizationArticles
          v-if="organization.tag"
          :tag="organization.tag"
        />
      </template>
    </LayoutGrid>
  </MpLoadingContainer>
</template>
